import { render, staticRenderFns } from "./DxpContainer.vue?vue&type=template&id=69d2f04c"
import script from "./DxpContainer.vue?vue&type=script&setup=true&lang=ts"
export * from "./DxpContainer.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./DxpContainer.vue?vue&type=style&index=0&id=69d2f04c&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports